import Vue from 'vue';
import App from './App';
import Buefy from 'buefy';
import VueMask from 'v-mask';
import router from './router';
import Roles from './mixins/roles';
import store from './store';
import VueMeta from 'vue-meta';
import i18n from '@/language/i18n';
import './validation';
import './signature';

Vue.config.productionTip = false;


Vue.use(Buefy);
Vue.use(VueMask);
Vue.use(VueMeta);
Vue.mixin(Roles);

Vue.filter('storageUrl', (path) => {
	if (!path) return '';
	if (path.startsWith('http')) return path;
	return process.env.VUE_APP_BASE_API + path;
});

new Vue({
	i18n,
	router,
	store,
	render: (h) => h(App),
	callRoleMixin: true
}).$mount('#app');

Vue.prototype.$callRoleMixin = false;
Vue.config.devtools = true;
